<template>
    <article>
        <Loader v-if="loading" :loading="true"></Loader>
        <section>
            <label required>{{ trads.componentType }}</label>
            <select v-model="value.componentType" :disabled="!createMode">
                <option :value="undefined">–––</option>
                <option v-for="type in componentTypes" :key="type.key" :value="type.value">{{ trads.compotentTypeNames[type.key] }}</option>
            </select>
            <label required>{{ trads.name }}</label>
            <TranslationInput v-model="value.name"></TranslationInput>
            <label required>{{ trads.shortName }}</label>
            <TranslationInput v-model="value.nickname"></TranslationInput>
            <label v-if="!isProduct && hasAccessApplication('plano_builder')" required>{{ trads.systemType }}</label>
            <CheckboxGroup
                v-if="!isProduct && hasAccessApplication('plano_builder')"
                id="system-types"
                name="system-type"
                v-model="value.selectedSystemTypes"
                :options="systemTypes"
            ></CheckboxGroup>
            <label v-if="!isProduct && hasAccessApplication('plano_builder')" required>{{ trads.availableOn.label }}</label>
            <CheckboxGroup
                v-if="!isProduct && hasAccessApplication('plano_builder')"
                id="available-on"
                v-model="value.selectedAvailableOn"
                :options="availableOn"
            ></CheckboxGroup>
            <label>{{ trads.design }}</label>
            <select v-model="value.standDesignId">
                <option :value="undefined">–––</option>
                <option v-for="design in standDesigns" :key="design.id" :value="design.id">{{ design.name }}</option>
            </select>
        </section>
    </article>
</template>

<script>
import TranslationInput from "./components/translation-input";
import CheckboxGroup from "./components/checkbox-group";
import RadioGroup from "./components/radio-group";
import standDesignService from "@/services/stand-design";
import TryLoadMixin from "@/mixins/TryLoadMixin";
import { COMPONENT_TYPE, ELEMENT_AVAILABILITY, SYSTEM_TYPE } from "@/services/component";
import Loader from "@/components/loader/loader";

// a filtered list of component type
const CREATE_COMPONENT_TYPE = {
    module: COMPONENT_TYPE.module,
    product: COMPONENT_TYPE.product,
    fascia: COMPONENT_TYPE.fascia,
    caddy: COMPONENT_TYPE.caddy,
    accessory: COMPONENT_TYPE.accessory,
    divider: COMPONENT_TYPE.divider,
    shelf: COMPONENT_TYPE.shelf,
    ticketStrip: COMPONENT_TYPE.ticketStrip,
    frame: COMPONENT_TYPE.frame,
    ladder: COMPONENT_TYPE.ladder,
    display: COMPONENT_TYPE.display,
    blankingGraphic: COMPONENT_TYPE.blankingGraphic
};

export default {
    mixins: [TryLoadMixin],
    components: { TranslationInput, CheckboxGroup, Loader, RadioGroup },
    props: {
        value: { type: Object, required: true },
        createMode: { type: Boolean, required: true }
    },
    data: () => ({
        standDesigns: []
    }),
    computed: {
        isProduct() {
            return this.value.componentType === COMPONENT_TYPE.product;
        },
        trads() {
            return this.$trad.admin.componentForm;
        },
        componentTypes() {
            const res = [];
            for (const key of Object.keys(CREATE_COMPONENT_TYPE)) {
                res.push({ key, value: CREATE_COMPONENT_TYPE[key] });
            }
            return res;
        },
        systemTypes() {
            const res = [];
            for (const key in SYSTEM_TYPE) {
                res.push({ value: SYSTEM_TYPE[key], label: this.trads.systemTypes[key] });
            }
            return res;
        },
        availableOn() {
            const res = [];
            for (const key of Object.keys(ELEMENT_AVAILABILITY)) {
                res.push({ value: ELEMENT_AVAILABILITY[key], label: this.trads.availableOn[key] });
            }
            return res;
        }
    },
    async created() {
        this.standDesigns = await this.tryLoad(() => standDesignService.getAll());
    }
};
</script>

<style lang="scss" scoped>
#main #component-form article {
    position: relative;

    #available-on,
    #system-types {
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// form-head.vue?25a01dae